import { useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { Button, Pagination } from '@mui/material';
import Helmet from '../../helmet/Helmet';
import { findProductsByCategory } from '../../state/Product/Action';
import { IMAGES_URL } from "../../config/apiConfig";
import debounce from 'lodash.debounce';
import './Product.css'

export default function Product() {
  const param = useParams();
  const dispatch = useDispatch();
  const [_productFull, _setProductFull] = useState([]);
  const [_product, _setProduct] = useState([]);
  const [_page, _setPage] = useState(1);
  const [_totalPages, _setTotalPages] = useState(1);
  const [_title, _setTitle] = useState('Thương hiệu thời trang Việt Nam.')
  const [_colors, _setColors] = useState([])
  const [_sizes, _setSizes] = useState([])
  const [sortOption, setSortOption] = useState('default');
  const [openDropdown, setOpenDropdown] = useState({}); // Trạng thái mở dropdown cho nhiều dropdown
  const [selectedValue, setSelectedValue] = useState('');
  const colorDropdownRef = useRef(null);
  const sizeDropdownRef = useRef(null);
  // Hàm để xử lý thay đổi sắp xếp
  const handleSortChange = (event) => {
    setSortOption(event.target.value);
    // Gọi API hoặc thực hiện hành động sắp xếp ở đây tùy theo lựa chọn
    //console.log(`Đang sắp xếp theo: ${event.target.value}`);
    const value = event.target.value;
    setSortOption(value);

    let sorted = [..._product];
    if (value === "newest") {
      sorted.sort((a, b) => new Date(b.ngaySanXuat) - new Date(a.ngaySanXuat));
    } else if (value === "price-low-to-high") {
      sorted.sort((a, b) => a.donGia - b.donGia);
    } else if (value === "price-high-to-low") {
      sorted.sort((a, b) => b.donGia - a.donGia);
    }
    _setProduct(sorted);

  };
  const toggleDropdown = (dropdownType) => {
    setOpenDropdown((prev) => ({
      color: dropdownType === 'color' ? !prev.color : false,
      size: dropdownType === 'size' ? !prev.size : false,
    }));
  };
 
  const toggleFilter = (value, type) => {
    setFilters((prev) => {
      const newValues = prev[type].includes(value)
        ? prev[type].filter((item) => item !== value)
        : [...prev[type], value];
  
      return { ...prev, [type]: newValues };
    });
  };
  


  const [filters, setFilters] = useState({
    colors: [],
    sizes: [],
    minPrice: 0,
    maxPrice: 10000,
    minDiscount: 0,
    stock: null,
    pageNumber: 1,
  });

  useEffect(() => {
    const fetchData = async () => {
      const data = { categoryId: param.categoryId, pageNumber: _page };
      const res = await dispatch(findProductsByCategory(data));
      if (!res) return;

      _setProductFull(res);
      _setPage(res.page);
      _setTotalPages(res.totalPages);
      _setProduct(res.data);
      if (Array.isArray(res.data) && res.data.length > 0) {
        // Tổng hợp màu sắc từ danh sách sản phẩm
        const processedColors = {};
        res.data.forEach((product) => {
          product.mauSac.forEach((color) => {
            if (!processedColors[color.maNhom]) {
              processedColors[color.maNhom] = { maNhom: color.maNhom, tenNhom: color.tenNhom };
            }
          });
        });
        _setColors(Object.values(processedColors));
        //setSelectedColor(Object.values(processedColors)[0] || null);

        // Tổng hợp kích thước từ danh sách sản phẩm, loại bỏ trùng và sắp xếp theo viTri
        const processedSizes = {};
        res.data.forEach((product) => {
          product.kichThuoc.forEach((size) => {
            if (!processedSizes[size.maSize]) {
              processedSizes[size.maSize] = { maSize: size.maSize.trim(), viTri: size.viTri };
            }
          });
        });

        // Chuyển thành mảng và sắp xếp theo viTri
        const sortedSizes = Object.values(processedSizes).sort((a, b) => a.viTri - b.viTri);
        _setSizes(sortedSizes);
      }
    };

    fetchData();
  }, [param.categoryId]);

  useEffect(() => {
    if (!Array.isArray(_productFull?.data) || _productFull.data.length === 0) return;
  
    let filteredProducts = [..._productFull.data];
  
    if (filters.sizes.length > 0) {
      filteredProducts = filteredProducts.filter(product =>
        product.kichThuoc.some(size => filters.sizes.includes(size.maSize))
      );
    }
  
    if (filters.colors.length > 0) {
      filteredProducts = filteredProducts.filter(product =>
        product.mauSac.some(color => filters.colors.includes(color.maNhom))
      );
    }
    _setProduct(filteredProducts);
  }, [filters, _productFull]);
  

  const handleLoadMore = async () => {
    const previousScrollPosition = window.scrollY; // Lưu vị trí cuộn trước khi tải dữ liệu mới
  
    const data = { categoryId: param.categoryId, pageNumber: _page + 1 };
    const res = await dispatch(findProductsByCategory(data));
  
    if (res) {
      _setPage((prev) => prev + 1);
      _setProduct((prevProducts) => [...prevProducts, ...res.data]); // Nối dữ liệu mới vào danh sách cũ
  
      setTimeout(() => {
        window.scrollTo({ top: previousScrollPosition, behavior: "smooth" }); // Cuộn về vị trí cũ
      }, 100); // Đợi React cập nhật DOM rồi mới cuộn
    }
  };
  



  return (
    <Helmet title={_title}>
      <div className="bg-white mx-auto max-w-7xl pt-20 sm:px-6 lg:px-8">
        {
          _productFull.data?.length > 0 ? (
            <main>
              <section className="pb-3 pt-1 pl-1 pr-1">
                <div className="grid grid-cols-1 gap-x-8 gap-y-10 lg:grid-cols-4">
                  <div className="lg:col-span-4 w-full">
                    {/* <div className="pt-5 pb-5 font-bold text-3xl">{_title}</div> */}
                    <div className="flex space-x-4"> {/* Đặt các button vào trong một div với class "flex" */}
                      {/* Màu sắc Button */}
                      < div className="relative inline-block text-left" ref={colorDropdownRef}>
                        <button
                          className="hover:transform-none hover:border-gray-700 hover:text-inherit inline-flex justify-between items-center w-full border border-gray-300 rounded-2xl px-4 py-2 bg-white text-sm font-medium text-gray-700 shadow-sm"
                          onClick={() => toggleDropdown('color')}
                        >
                          {openDropdown.color ? 'Màu sắc' : 'Màu sắc'}
                          <svg
                            className={`-mr-1 ml-2 h-5 w-5 transform duration-200 ${openDropdown.color ? 'rotate-180' : 'rotate-0'}`}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 3a1 1 0 011 1v10.586l3.293-3.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>
                        {openDropdown.color && (
                          <div className="absolute left-0 z-10 mt-2 w-60 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 " role="menu">
                            <div className="row-start-1 grid grid-cols-2 gap-x-4 gap-y-2 text-sm bg-white/95 pl-2  shadow-md ">
                              {_colors.map((color) => (
                                <div
                                  key={color.maNhom}
                                  className="px-1 py-2 hover:bg-gray-100 flex items-center "
                                >
                                  <label className="flex items-center w-full relative">
                                    {/* Checkbox hidden */}
                                    <input
                                      type="checkbox"
                                      className="mr-2 h-6 w-6 opacity-0 absolute"
                                      checked={filters.colors.includes(color.maNhom)}
                                      onChange={() => toggleFilter(color.maNhom, 'colors')}
                                    />

                                    {/* Custom checkbox */}
                                    <div
                                      className="w-6 h-6 border-2 border-gray-300 rounded-full relative"
                                      style={{
                                        backgroundColor: '#' + color.maNhom, // Always show color as background
                                      }}
                                    >
                                      {/* Checkmark (only visible when checked) */}
                                      {filters.colors.includes(color.maNhom) && (
                                        <span className="absolute inset-0 flex justify-center items-center">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        </span>
                                      )}
                                    </div>

                                    <span
                                      className="text-sm font-medium ml-2"

                                    >
                                      {color.tenNhom}
                                    </span>
                                  </label>
                                </div>
                              ))}

                            </div>
                          </div>
                        )}
                      </div>

                      {/* Kích cỡ Button */}
                      <div className="relative inline-block text-left" ref={sizeDropdownRef}>
                        <button
                          className=" hover:transform-none hover:border-gray-700 hover:text-inherit inline-flex justify-between items-center w-full border border-gray-300 rounded-2xl px-4 py-2 bg-white text-sm font-medium text-gray-700 shadow-sm focus:border-gray-700"
                          onClick={() => toggleDropdown('size')}
                        >
                          {openDropdown.size ? 'Kích cỡ' : 'Kích cỡ'}
                          <svg
                            className={`-mr-1 ml-2 h-5 w-5 transform duration-200 ${openDropdown.size ? 'rotate-180' : 'rotate-0'}`}
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            aria-hidden="true"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 3a1 1 0 011 1v10.586l3.293-3.293a1 1 0 111.414 1.414l-5 5a1 1 0 01-1.414 0l-5-5a1 1 0 111.414-1.414L9 14.586V4a1 1 0 011-1z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </button>

                        {openDropdown.size && (
                          <div className="absolute left-0 z-10 mt-2 w-48 bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 " role="menu">
                            <div className="row-start-1 grid grid-cols-2  py-1">
                              {_sizes.map((size) => (
                                <div key={size.maSize} className="px-4 py-2 hover:bg-gray-100">
                                  <label className="flex items-center w-full relative">
                                    {/* Checkbox hidden */}
                                    <input
                                      type="checkbox"
                                      className="mr-2 h-5 w-5 opacity-0 absolute"
                                      checked={filters.sizes.includes(size.maSize)}
                                      onChange={() => toggleFilter(size.maSize, 'sizes')}
                                    />

                                    {/* Custom checkbox */}
                                    <div
                                      className="w-5 h-5 border-2 border-gray-300 rounded-sm relative"
                                      style={{
                                        backgroundColor: filters.sizes.includes(size.maSize) ? '#000' : 'transparent',  // Nền đen khi được chọn
                                      }}
                                    >
                                      {/* Checkmark (only visible when checked) */}
                                      {filters.sizes.includes(size.maSize) && (
                                        <span className="absolute inset-0 flex justify-center items-center">
                                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                            <path d="M20 6L9 17l-5-5" />
                                          </svg>
                                        </span>
                                      )}
                                    </div>

                                    <span
                                      className="text-sm font-medium ml-2"
                                      style={{
                                        color: '#000', // Màu chữ đen cho tất cả các size
                                      }}
                                    >
                                      {size.maSize}
                                    </span>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>
                        )}
                      </div>

                    </div>

                    <div className='right-0 w-full'>
                      <div className="flex items-center justify-end mt-4">
                        <div className="relative inline-block text-left">
                          {/* Sắp xếp */}
                          <select
                            value={sortOption}
                            onChange={handleSortChange}
                            className="hover:transform-none hover:border-gray-700 hover:text-inherit block w-48 py-2 px-3 border border-gray-300 rounded-md bg-white text-sm text-gray-700 shadow-sm "
                          >
                            <option value="default">Sắp xếp theo: Mặc định</option>
                            <option value="newest">Mới nhất</option>
                            <option value="price-low-to-high">Giá thấp đến cao</option>
                            <option value="price-high-to-low">Giá cao đến thấp</option>
                          </select>
                        </div>


                      </div>
                    </div>


                    <div className="pt-3 grid grid-cols-2 gap-x-6 gap-y-10 sm:grid-cols-2 md:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 xl:gap-x-8">

                      {_product?.map((product) => {
                        // Kiểm tra nếu có danh sách kích thước
                        const sortedSizes = product.kichThuoc ? [...product.kichThuoc].sort((a, b) => a.viTri - b.viTri) : [];
                        const firstSize = sortedSizes.length > 0 ? sortedSizes[0].maSize : null;
                        const lastSize = sortedSizes.length > 0 ? sortedSizes[sortedSizes.length - 1].maSize : null;

                        // Lọc danh sách màu sắc (tối đa 3 màu + dấu "+")
                        const displayedColors = product.mauSac ? product.mauSac.slice(0, 3) : [];
                        const moreColors = product.mauSac && product.mauSac.length > 3;

                        return (
                          <a key={product.maSanPham} href={`/san-pham/${product.maSanPham}.html`} className="group block">
                            <div className="k_img overflow-hidden rounded-lg bg-gray-200">
                              <img
                                src={`${IMAGES_URL}${product.maSanPham.trim()}-00.jpg`}
                                alt={product.tenSanPham}
                                className="h-full w-full object-cover object-center group-hover:opacity-75"
                                onError={(i) => (i.target.style.display = 'none')}
                              />
                            </div>

                            {/* Hàng chứa màu sắc bên trái và kích thước bên phải */}
                            <div className="mt-2 flex items-center justify-between">
                              {/* Danh sách màu sắc bên trái */}
                              <div className="flex items-center">
                                {displayedColors.map((color, index) => (
                                  <div
                                    key={index}
                                    className="w-5 h-5 rounded-full border border-gray-300"
                                    style={{ backgroundColor: '#' + color.maMau, marginRight: '4px' }}
                                  ></div>
                                ))}
                                {moreColors && <span className="text-sm font-semibold">+{product.mauSac.length - 3}</span>}
                              </div>

                              {/* Danh sách kích thước bên phải */}
                              {firstSize && lastSize && (
                                <p className="text-xs text-gray-500">Size: {firstSize} - {lastSize}</p>
                              )}
                            </div>

                            <h3 className="mt-2 text-sm text-gray-700">
                              {product.tenSanPham} ({product.maSanPham})
                            </h3>

                            <p className="mt-1 text-md font-medium text-gray-900">
                              {new Intl.NumberFormat('vi-VN', {
                                style: 'currency',
                                currency: 'VND',
                              }).format(product.donGia * 1000)}
                            </p>
                          </a>
                        );
                      })}



                    </div>
                    <div className="px-4 py-4 flex justify-center">
                      {_totalPages > _page && (
                        <a
                        onClick={handleLoadMore}
                          className="px-4 py-2 text-blue-800 rounded-lg hover:text-orange-800 transition cursor-pointer"
                        >
                          Xem thêm
                        </a>
                      )}
                    </div>

                  </div>
                </div>
              </section>
            </main>
          ) : (
            <div className="min-h-[85vh] grid justify-center content-center">
              <p>- Sản phẩm đang được cập nhật.</p>
            </div>
          )}
      </div>
    </Helmet>
  );
}
